import { Link } from '@ipfabric/ui-components/Link/Link';
import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import type { FC } from 'react';
import {
  type AimFlowPathLookupBody,
  useCalculateDevices,
} from './useCalculateDevices';

const CALCULATE_TOOLTIP = 'Calculate path-lookups for this flow.';

/**
 * Text-link form of the calculate trigger, used in the Flows `Calculation status` cell.
 *
 * The cell shows either the device count or this link, never both: once a flow is
 * calculated its result cannot go stale, because topology changes only arrive
 * with a new snapshot and a new snapshot starts with nothing calculated.
 */
export const AimCalculateDevicesLink: FC<{ body: AimFlowPathLookupBody }> = ({
  body,
}) => {
  const { calculate, scheduling, disabled } = useCalculateDevices(body);

  return (
    <Tooltip content={CALCULATE_TOOLTIP}>
      {/* Tooltip clones its child to attach the hover handlers, and a disabled
          control is `pointer-events-none` — so the wrapper is what keeps the
          tooltip working while a calculation is being scheduled. */}
      <span className='inline-flex'>
        {/* Default size (text-sm) rather than 'small' (text-xs), so the trigger
            matches the "Calculated" text it alternates with in the same column. */}
        <Link
          renderAs='button'
          type='button'
          onClick={calculate}
          loading={scheduling}
          disabled={disabled}
        >
          Calculate
        </Link>
      </span>
    </Tooltip>
  );
};
